import React from "react";
import user from "../MemberButton/assets/user.png";
import exChange from "./assets/exchange.png";
import logout from "./assets/logout.png";
import blackUserLogo from "./assets/user-circle.png";
import { Link } from "react-router-dom";
import { NavLink } from "react-router-dom";
const UserNav = ({ setUser, setSelectedNft, setWallet, setOpen }) => {
  return (
    <div>
      <div className="flex relative group cursor-pointer">
        <div className="text-[#0E0E0E] font-bold text-[15px] leading-[18px] h-[40px] flex justify-center items-center w-[145px] rounded-l-[20px] bg-main-green">
          <span>0x7ga....25fp3</span>
        </div>
        <div className="w-[92px] bg-main-black rounded-r-[20px] h-[40px] font-bold text-[15px] leading-[18px] flex gap-[10px] items-center text-white">
          <h2 className="pl-[12px]">Tier 1</h2>
          <img src={user} alt="" />
        </div>
        <div className="absolute invisible group-hover:visible hidden group-hover:block  right-0 translate-y-full pt-[10px] bottom-0">
          <div className=" w-[141px] bg-main-green py-[10px] px-[5px]  md:px-[17px] rounded-[10px]">
            <ul className="flex justify-start flex-col items-start">
              <li className="mb-[5px] w-full">
                <NavLink
                  to="/my-profile"
                  className="text-main-black font-bold text-[15px] leading-[18px] block hover:opacity-80 opacity-100 transition-all"
                >
                  <div className="flex justify-start items-center gap-[5px]">
                    <img src={blackUserLogo} alt="" />
                    <span className="">My Profile</span>
                  </div>
                </NavLink>
              </li>
              <li className="mb-[5px]">
                <button
                  onClick={() => {
                    setOpen(true);
                    setSelectedNft("");
                  }}
                  className="text-main-black font-bold text-[15px] leading-[18px] block hover:opacity-80 opacity-100 transition-all"
                >
                  <div className="flex items-center gap-[5px]">
                    <img src={exChange} alt="" />
                    <span className="">Change NFT</span>
                  </div>
                </button>
              </li>
              <li className="mb-[5px]">
                <button
                  onClick={() => {
                    setSelectedNft("");
                    setUser(false);
                    setWallet("");
                  }}
                  className="text-main-black font-bold text-[15px] leading-[18px] block hover:opacity-80 opacity-100 transition-all"
                >
                  <div className="flex items-center gap-[5px]">
                    <img src={logout} alt="" />
                    <span className="">Logout</span>
                  </div>
                </button>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserNav;
